import React from "react";
import { Tooltip } from "@mui/material";
import MDButton from "components/MDButton";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

/**
 * Botón para abrir la proforma PDF de un estudiante en una nueva pestaña.
 *
 * @param {number} estudianteId - ID del estudiante
 */
function ProformaButton({ estudianteId }) {
  const handleOpenPdf = () => {
    const url = `${process.env.REACT_APP_API_URL}/proforma/${estudianteId}`;
    window.open(url, "_blank"); // abre directamente la URL
  };

  return (
    <Tooltip title="Ver Proforma PDF">
      <MDButton color="warning" onClick={handleOpenPdf}>
        <PictureAsPdfIcon sx={{ fontSize: 28 }} />
      </MDButton>
    </Tooltip>
  );
}

export default ProformaButton;
